import type { BlendMode } from './types';

/**
 * Canvas compositing helpers.
 *
 * The document model uses CSS `mix-blend-mode` names because they are the
 * readable, complete set. Canvas2D `globalCompositeOperation` uses the same
 * names except for "normal", which is "source-over".
 */
export function blendModeToComposite(mode: BlendMode): string {
  return mode === 'normal' ? 'source-over' : mode;
}

export function degreesToRadians(angle: number): number {
  return (angle * Math.PI) / 180;
}
